module.exports = __webpack_public_path__ + "img/help-ct2.acd2b391.png";